import { render } from "./AiDevelopmentSection.vue?vue&type=template&id=10e4a67c&scoped=true"
import script from "./AiDevelopmentSection.vue?vue&type=script&lang=js"
export * from "./AiDevelopmentSection.vue?vue&type=script&lang=js"

import "./AiDevelopmentSection.vue?vue&type=style&index=0&id=10e4a67c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e4a67c"]])

export default __exports__